<template>
  <div class="userinfo">
    <header-bar :name='"获奖证书"'></header-bar>
    <div class="info_wrap">
      <div class="altas_info">
        <div class="cover_con" :class="{'cover_con_2': !picData.length}">
          <!-- <img src="../img/m/no_certificate.png" alt="" v-if="!picData.length"> -->
          <!-- <img src="../img/m/no_certificate.png" alt="" v-if="!picData.length"> -->
          <img :src="picData.image_url" alt="">
        </div>
        <div class="btn" @click="goForm()" v-if="picData.award_title != '参与奖'">填写领奖信息</div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { Notify } from 'vant'
import {mapGetters, mapActions} from 'vuex'
import headerBar from './common/headerBar'
import aliPlayer from './common/aliplayer'
import commonFooter from './common/commonFooter'

export default {
  components: {
    headerBar,
    aliPlayer,
    commonFooter
  },
  data () {
    return {
      picData: {},
      resultShow: false,
      videoShow: false,
      PlayAuth: ''
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.checkUser()
    this.getworkInfo()

  },
  methods: {
    //判断用户
    checkUser(){
      console.log(this.getUserInfo)
      if( this.getUserInfo.have_award != 1 ){
        this.$message({
          message: '您未获奖，无权限访问',
          type: 'warning'
        });
        this.$router.push('/mpage/m_home');
      }
    },
    goForm () {
      this.$router.push({
        path: '/mpage/m_certificateForm'
      })
    },
    getworkInfo () {
      this.$utils.get('/user/api/get-my-award').then(res => {
        if (res.code == 1000) {
          this.picData = res.data
        }
      })
    },
    getPlayAuth () {
      this.$utils.get('/works/getPlayAuth', {video_id: this.picData.video_url}).then(res => {
        if (res.code == 1000) {
          this.PlayAuth = res.data.PlayAuth
          this.videoShow = true
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.userinfo {
  min-height: 100vh;
  background: #ededf6;
  .info_wrap {
    padding: .28rem .44rem 0rem;
    .altas_info {
      background: #fff;
      min-height: calc(100vh - 8rem);
      padding: .45rem;
      box-sizing: border-box;
      .cover_con {
        position: relative;
        box-sizing: border-box;
        &.cover_con_2 {
          border: 1px solid #000000;
          padding: .7rem;
        }
        img {
          display: block;
          width: 100%;
        }
      }
      .btn {
        background-color: #7895d8;
        border-radius: .6rem;
        border: solid .03rem #c2c2cb;
        width: 4.5rem;
        height: 1.2rem;
        font-size: .36rem;
        color: #fff;
        text-align: center;
        line-height: 1.2rem;
        margin: auto;
        margin-top: .6rem;
      }
    }
  }

}
</style>
